import { render, staticRenderFns } from "./ComponentSocial.vue?vue&type=template&id=4a63afbe"
import script from "./ComponentSocial.vue?vue&type=script&lang=js"
export * from "./ComponentSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports